module.exports = __webpack_public_path__ + "img/专家线下评议.a777b4a1.png";